export default [
    {
        id: 1,
        "currency": '$',
        "price": '590',
        "owner": 'Trap',
        "negotiation": '589',
        "action": 'Approve'
    },
    {
        id: 2,
        "currency": '$',
        "price": '590',
        "owner": 'Trap',
        "negotiation": '589',
        "action": 'Approve'
    },

    {
        id: 3,
        "currency": '$',
        "price": '590',
        "owner": 'Trap',
        "negotiation": '589',
        "action": 'Approve'
    
    },

    {
        id: 4,
        "currency": '$',
        "price": '590',
        "owner": 'Trap',
        "negotiation": '589',
        "action": 'Approve'
    },
    {
        id: 5,
        "currency": '$',
        "price": '590',
        "owner": 'Trap',
        "negotiation": '589',
        "action": 'Approve'
    },


]